import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';

import Dropdown from './Dropdown';

const propTypes = {};
const YEARS = [1, 2, 3];

const messages = defineMessages({
  cloudSubscriptionYears: {
    id: 'checkout.subscription.length',
    defaultMessage: '{year} Year Subscription',
  },
});

function SubscriptionInput({ value = 1, id, onChange, editable }) {
  const title = (
    <FormattedMessage
      {...messages.cloudSubscriptionYears}
      values={{ year: value }}
    />
  );
  if (!editable) return <span>{title}</span>;

  return (
    <Dropdown title={title} id={id}>
      {YEARS.map(year => (
        <Dropdown.Item
          key={year}
          onClick={() => onChange(year)}
          active={value === year}
        >
          <FormattedMessage
            {...messages.cloudSubscriptionYears}
            values={{ year }}
          />
        </Dropdown.Item>
      ))}
    </Dropdown>
  );
}

SubscriptionInput.propTypes = propTypes;

export default SubscriptionInput;
